export const handleApiError = (
    error,
    thunkAPI,
    defaultMessage = "Something went wrong",
    key = null
) => {
    const apiError = error?.response?.data;
    let message = defaultMessage;

    if (apiError?.errors) {
        message = Object.values(apiError.errors).flat();
    } else if (apiError?.message) {
        message = apiError.message;
    }

    if (key) {
        return thunkAPI.rejectWithValue({
            key,
            error: Array.isArray(message) ? message : [message],
        });
    }

    return thunkAPI.rejectWithValue(
        Array.isArray(message) ? message : [message]
    );
};